// extracted by mini-css-extract-plugin
module.exports = {"UploadContainer":"PackageFormAVE_UploadContainer__2ggpF","previewContainer":"PackageFormAVE_previewContainer__3gcef"};